import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Renderer2,
  ChangeDetectorRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Router } from "@angular/router";
import { ZpDataService } from "../services/zp-data.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { Subscription } from "rxjs";
import { ProfessionalFeaturesService } from "../services/professional-features.service";

@Component({
    selector: "app-dynamic-dropdown",
    templateUrl: "./dynamic-dropdown.component.html",
    styleUrls: ["./dynamic-dropdown.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DynamicDropdownComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class DynamicDropdownComponent implements OnInit {
  @Input() public myUser: any;
  @Input() public invalid: string;
  @Input() public change;
  @Input() public required: string;
  @Input() public optional: string;
  @Input() public myLabel = "";
  @Input() public value;
  @Input() public id = "";
  @Input() public optionCollection;
  @Input() public optionViewProperty;
  @Input() public optionValueProperty;
  @Input() public companyDetails;

  onTouched = () => {};
  onChange = (_) => {};
  @ViewChild("input", { static: true, read: ElementRef })
  public dropdownElementRef: ElementRef;
  @Input() public animate: boolean = false;
  public contributor: boolean = false;
  public now: boolean = false;
  public future: boolean;
  public never: boolean;
  public href: string = "";
  public currentSection: string;
  public capitalize: boolean = false;
  public user: any;
  public refCode: any;
  public displayContributorByDefault: boolean;
  public userType: string;
  public isFocused: boolean;
  displayContributor: boolean;
  displayDelegateRelation: any;
  subscription: Subscription;
  @Input() selectedOption: string = " ";
  @Input() state: string;
  @Input() myFormGroup: any;
  @Input() permissionState: string;
  isNFZ: any;
  dataIsLoaded: boolean;

  constructor(
    private _renderer: Renderer2,
    private router: Router,
    private api: ZpDataService,
    private getInfoAndPass: GetInfoAndPassService,
    private cdr: ChangeDetectorRef,
    private professionalFeatures: ProfessionalFeaturesService
  ) {}

  @Output("focusout") public focusOutEmitter: EventEmitter<any> =
    new EventEmitter();
  @Output("change") public changeEmitter: EventEmitter<any> =
    new EventEmitter();

  ngOnInit() {
    this.href = this.router.url;
    if (this.myUser) {
      this.userType = this.myUser.userType;
    }
    switch (this.href) {
      case "/dynamicformdataentry/delegate_3_1":
        this.currentSection = "assets";
        console.log("currentSection", this.currentSection);
        if (this.userType === "planHolder") {
          this.displayContributor = true;
          this.contributor = true;
        }
        break;
      case "/dynamicformdataentry/delegate_3_2":
        this.currentSection = "debts";
        console.log("currentSection", this.currentSection);
        if (this.userType === "planHolder") {
          this.displayContributor = true;
          this.contributor = true;
        }
        break;
      case "/dynamicformdataentry/delegate_3_3":
        this.currentSection = "daily life";
        console.log("currentSection", this.currentSection);
        if (this.userType === "planHolder") {
          this.displayContributor = true;
          this.contributor = true;
        }
        break;
      case "/dynamicformdataentry/delegate_3_5":
        this.currentSection = "digital life";
        console.log("currentSection", this.currentSection);
        if (this.userType === "planHolder") {
          this.displayContributor = true;
          this.contributor = true;
        }
        break;
      case "/dynamicformdataentry/delegate_3_4":
        this.currentSection = "wishes";
        console.log("currentSection", this.currentSection);
        if (this.userType === "planHolder") {
          console.log("planHolder");
          this.displayContributor = true;
          this.contributor = true;
        }
        break;
      case "/dynamicformdataentry/delegate_3_6":
        this.animate = true;
        break;
    }
    setTimeout(() => {
      console.log("value in dropdown", this.dropdownElementRef.nativeElement.value);
      if (this.dropdownElementRef.nativeElement.value) {
        this.animate = true;
      } else {
        this.animate = false;
      }
    }, 500);
    this.onDropdownChange(this.selectedOption);
    this.loadProfessionalDataForNFZ();
  }

  async loadProfessionalDataForNFZ() {
    // Use methods from ProfessionalFeaturesService
    await this.professionalFeatures.checkProfessionalCompanyDetails(this.myUser);

    // Access companyDetails from ProfessionalFeaturesService
    this.companyDetails = this.professionalFeatures.companyDetails;
    console.log("companyDetails - ", this.companyDetails);
    if (this.companyDetails && this.companyDetails.nfz) {
      this.isNFZ = true;
    } else {
      this.isNFZ = false;
    }

    // Set dataIsLoaded to true
    this.dataIsLoaded = true;
  }

  passOnChange(event: any) {
    this.changeEmitter.emit(event);
  }

  onDropdownChange(event) {
    const value = this.dropdownElementRef.nativeElement.value;
    if (value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
    switch (value) {
      case "contributor":
        this.contributor = true;
        this.now = false;
        this.future = false;
        this.never = false;
        break;
      case "now":
        this.contributor = false;
        this.now = true;
        this.future = false;
        this.never = false;
        break;
      case "future":
        this.contributor = false;
        this.now = false;
        this.future = true;
        this.never = false;
        break;
      case "never":
        this.contributor = false;
        this.now = false;
        this.future = false;
        this.never = true;
        break;
    }
    this.handleLabel();
    this.onChange(value);
    console.log("value", value);
  }

  onBlur() {
    this.onTouched();
    this.focusOutEmitter.emit();
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: string) {
    this._renderer.setProperty(
      this.dropdownElementRef.nativeElement,
      "value",
      value
    );
  }

  setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(
      this.dropdownElementRef.nativeElement,
      "disabled",
      isDisabled
    );
  }
  handleLabel() {
    if (this.dropdownElementRef.nativeElement.value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.getInfoAndPass.clearData();
  }
}
